<div class="container">
  <div class="text-center mb-4">
    <strong style="font-size: 1.5rem; color: #8e0e00">Notifications</strong>
  </div>

  <div class="row">
    <!-- Buttons -->
    <div
      class="col-lg-9 col-md-9 col-sm-12 toolbar d-flex align-items-center gap-2"
    >
      <button class="btn btn-success" ngbTooltip="Export to excel">
        <span><i class="bi bi-box-arrow-up me-2"></i></span> Export
      </button>
      <!-- <button class="btn btn-success" ngbTooltip="Print">
            <span><i class="bi bi-printer me-2"></i></span>Print
        </button> -->
      <button class="btn btn-success" ngbTooltip="Clear filter">
        <span> <i class="bi bi-x-circle me-2"></i></span>Clear
      </button>
    </div>
    <!-- Search -->
    <div class="col-lg-3 col-md-3 mt-3 col-sm-12">
      <input
        type="text"
        class="form-control"
        placeholder="Search..."
        (input)="onSearch($event)"
      />
    </div>
  </div>

  <div class="card p-3 shadow-lg mt-3">
    <ul
      class="nav nav-tabs cursor-pointer mt-3"
      id="myTab"
      role="tablist"
      style="cursor: pointer"
    >
      <li class="nav-item" role="presentation">
        <a
          class="nav-link"
          [class.active]="activeTab === 'all'"
          (click)="setActiveTab('all')"
        >
          All
        </a>
      </li>
      <li class="nav-item" role="presentation">
        <a
          class="nav-link"
          [class.active]="activeTab === 'requestor'"
          (click)="setActiveTab('requestor')"
        >
          Requestor
        </a>
      </li>
      <li class="nav-item" role="presentation">
        <a
          class="nav-link"
          [class.active]="activeTab === 'dumpster'"
          (click)="setActiveTab('dumpster')"
        >
          Dumpster
        </a>
      </li>
      <li class="nav-item" role="presentation">
        <a
          class="nav-link"
          [class.active]="activeTab === 'dumpyard'"
          (click)="setActiveTab('dumpyard')"
        >
          Dump yard
        </a>
      </li>
    </ul>

    <div
      class="table-responsive mt-3"
      style="max-height: 500px; overflow-y: auto"
    >
      <table class="table table-striped table-bordered text-center">
        <thead>
          <tr>
            <!-- <th class="text-center" *ngFor="let row of tableHeaders;">
                            {{ row }}
                            <i *ngIf="['City', 'Zone', 'User Type', 'Notification Category'].includes(row)"
                                class="bi bi-funnel ms-2 " (click)="toggleDropdown(row)"></i>
                           
                            <div *ngIf="activeDropdown === row" class="dropdown-menu show">
                                <div class="px-3 py-2">
                                    <div class="filter-options" style="max-height: 200px; overflow-y: auto;">
                                        <div *ngFor="let option of availableFilters[row]" class="dropdown-item"
                                            (click)="applyFilter(row, '')">
                                            {{ option }}
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </th> -->

            <th class="text-center">User ID</th>
            <th class="text-center">
              User Type
              <!-- <i
                class="bi bi-funnel"
                id="dumpedStatusDropdown"
                data-bs-toggle="dropdown"
              ></i>

              <ul class="dropdown-menu" aria-labelledby="dumpedStatusDropdown">
                <li>
                  <a class="dropdown-item">All</a>
                </li>
                <li>
                  <a class="dropdown-item"> Individual Requester </a>
                </li>
                <li>
                  <a class="dropdown-item"> Dumpster </a>
                </li>
              </ul> -->
            </th>
            <th class="text-center">User Name</th>
            <th class="text-center">Mobile No</th>
            <th class="text-center">
              City

              <!-- <i
                class="bi bi-funnel"
                id="dumpedStatusDropdown"
                data-bs-toggle="dropdown"
              ></i>

              <ul class="dropdown-menu" aria-labelledby="dumpedStatusDropdown">
                <li>
                  <a class="dropdown-item">All</a>
                </li>
                <li>
                  <a class="dropdown-item"> Chennai </a>
                </li>
              </ul> -->
            </th>
            <th class="text-center">
              Zone

              <!-- <i
                class="bi bi-funnel"
                id="dumpedStatusDropdown"
                data-bs-toggle="dropdown"
              ></i>

              <ul class="dropdown-menu" aria-labelledby="dumpedStatusDropdown">
                <li>
                  <a class="dropdown-item">All</a>
                </li>
                <li>
                  <a class="dropdown-item"> Nolambur </a>
                </li>
              </ul> -->
            </th>
            <th class="text-center">Notifications</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let row of pagedData; let i = index">
            <td class="text-center">{{ row.userId }}</td>
            <td class="text-center">{{ row.userType }}</td>
            <td class="text-center">{{ row.userName }}</td>
            <td class="text-center">{{ row.mobileNo }}</td>
            <td class="text-center">{{ row.city }}</td>
            <td class="text-center">{{ row.zone }}</td>
            <!-- <td class="text-center">{{ row.notificationCategory }}</td> -->
            <td class="text-start">{{ row.notification }}</td>
          </tr>
          <tr *ngIf="!pagedData || pagedData.length === 0">
            <td colspan="8" class="text-center">
              <h3>No Data Found</h3>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
    <!-- Pagination -->
    <div class="d-flex justify-content-between align-items-center mt-3">
      <!-- Pagination Centered -->
      <div class="d-flex justify-content-center flex-grow-1">
        <ngb-pagination
          *ngIf="allNotification?.length > 0"
          [(page)]="page"
          [pageSize]="pageSize"
          [collectionSize]="allNotification?.length"
          [maxSize]="3"
          (pageChange)="onPageChange($event)"
          [boundaryLinks]="true"
        >
        </ngb-pagination>
      </div>

      <!-- Entries Message Aligned to the End -->
      <div *ngIf="allNotification?.length > 0" class="text-muted mb-3">
        <strong
          >Showing {{ (page - 1) * pageSize + 1 }} to
          {{
            page * pageSize > allNotification?.length
              ? allNotification?.length
              : page * pageSize
          }}
          of {{ allNotification?.length }} entries</strong
        >
      </div>
    </div>
  </div>
</div>
